import React, { Component } from 'react'
import EntityList from './entityList';

class EntiySelector extends Component {
  constructor(props, context) {
    super(props, context);

    this.onEntitySelection = this.onEntitySelection.bind(this);

    this.state = {
      selectedEntity : null
    };
  }  

  onEntitySelection(entity){
    this.state.selectedEntity = entity;
  }

  render() {
    return (
      <EntityList apiRoute={this.props.apiRoute} onEntitySelection={this.onEntitySelection} title={this.props.title} allowSelection={true} allowEdit={false} displayColumns={this.props.displayColumns} defaultOrderBy={this.props.defaultOrderBy}/>
    )
  }
}

export default EntiySelector;



/** WEBPACK FOOTER **
 ** ./src/app/components/entitySelector.js
 **/